import React from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import './style.css'

/* global API */

const formatPhone = value => {
    value = value ? value.replace(/\D/g, '') : ''
    value = value ? value.replace(/^7/, '+7') : ''
    value = value ? value.replace(/^8/, '+7') : ''
    if (value && value.indexOf('+7') !== 0) value = '+7' + value;
    if (value.length > 2) value = value.substr(0, 2) + ' ' + value.substr(2)
    if (value.length > 6) value = value.substr(0, 6) + ' ' + value.substr(6)
    if (value.length > 10) value = value.substr(0, 10) + '-' + value.substr(10)
    if (value.length > 13) value = value.substr(0, 13) + '-' + value.substr(13)
    return value
}

const RegistrationRoute = () => {
    const { invite } = useParams()
    const [inviteAuthor, setInviteAuthor] = React.useState(false)

    const { register, setValue, handleSubmit, watch } = useForm({
        mode: 'onSubmit',
        defaultValues: {
            invite
        }
    })

    const watchPhone = watch('phone', '');

    // Submit
    const history = useHistory()
    const [errorMessage, setErrorMessage] = React.useState('')

    const onSubmit = async (values) => {
        const data = await API.instance().register(values)

        if (!!data.token) {
            API.instance().setToken(data.token)
            localStorage.setItem('token', data.token)
            history.push('/')
        }
        else {
            setErrorMessage(`
                Не удалось зарегистрировать вас в Клубе.
                Или такой телеграм-логин уже есть в нашей базе, или какая-то хуйня случилась.
                Расскажите об этом тому, кто вас пригласил.
            `)
        }
    }

    // setValue('phone', formatPhone( watch('phone') && watch('phone').toString() ) )

    React.useEffect(() => {
        API.instance().getInviteAuthor(invite).then(author => {
            setInviteAuthor(author.length && author)
        })
        setValue('phone', formatPhone(watchPhone.toString()))
    }, [invite, watchPhone, setValue])




    return (
        <div>
            { !!inviteAuthor &&

                <div className="page registration-page">
                    <h1 className="registration-page__h1">Регистрация в Клубе</h1>
                    <div className="page__inner">
                        <div className="container">
                            <p>{inviteAuthor} зовет вас в Клуб. Ура!</p>
                            <p>Заполните форму честно и полностью: эта информация пригодится участникам Клуба, чтобы с вами связаться или поделиться доступами. Все данные будут доступны только участникам, мы не шлем спам и не храним пароли.</p>
                        </div>
                        <div className="container">
                            <form
                                onSubmit={handleSubmit(onSubmit)}
                                // onChange={handleChange(onChange)}
                                className="form_register"
                            >
                                <div className="form_register__field">
                                    <input
                                        ref={register({ required: true })}
                                        type="hidden"
                                        name="invite"
                                        className="form_register__input"
                                    />
                                </div>
                                <div className="form_register__field">
                                    <label>Телеграм-логин (без @)</label>
                                    <input
                                        ref={register({ required: true })}
                                        type="text"
                                        name="telegram"
                                        className="form_register__input"
                                    />
                                </div>
                                <div className="form_register__field">
                                    <label>Пароль</label>
                                    <input
                                        ref={register({ required: true })}
                                        type="password"
                                        name="password"
                                        className="form_register__input"
                                    />
                                </div>
                                <div className="form_register__field">
                                    <label>Имя</label>
                                    <input
                                        ref={register({ required: true })}
                                        type="text"
                                        name="name"
                                        className="form_register__input"
                                    />
                                </div>
                                <div className="form_register__field">
                                    <label>Фамилия</label>
                                    <input
                                        ref={register({ required: true })}
                                        type="text"
                                        name="surname"
                                        className="form_register__input"
                                    />
                                </div>
                                <div className="form_register__field">
                                    <label>Телефон</label>
                                    <input
                                        ref={register({ required: true })}
                                        type="text"
                                        name="phone"
                                        className="form_register__input"
                                    />
                                </div>
                                <div className="form_register__field">
                                    <label style={{ lineHeight: 1.1, marginBottom: .5 + "rem" }}>
                                        Электронная почта
                                <small> (лучше гугловская — для календаря, ноушена и прочих сервисов)</small>
                                    </label>
                                    <input
                                        ref={register({ required: true })}
                                        type="text"
                                        name="email"
                                        className="form_register__input"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={false}
                                    className="form_register__button form_register__button_submit"
                                >
                                    Войти в Клуб
                        </button>
                            </form>

                            {!!errorMessage &&
                                <div className="message_error">{errorMessage}</div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default RegistrationRoute
